import { memo, useEffect, useState } from 'react'
import Image from 'next/image'
import { getQuickScans } from '@helpers/challanQuickScans'
import { statusConfig } from './challan.config'
import styles from './WhatsappChallanNewFlow.module.scss'
import { IQuickScan } from './interfaces'
import { WHATSAPP_CHALLAN_JOURNEY, WHATSAPP_CHALLAN_PAGE_TYPE } from './enums'

const QuickScan = ({
  setshowQuickScan,
  state,
  isNonVahanState,
  isNationalVehicle,
  onComplete,
  vasAmount,
}: IQuickScan) => {
  const [loaded, setLoaded] = useState(false)
  const { heading, quickScansList: scanList } = getQuickScans(state, isNonVahanState, isNationalVehicle)
  const scanListLength = scanList?.length || 0

  useEffect(() => {
    if (loaded) {
      setshowQuickScan(false)
      onComplete({
        pageName: WHATSAPP_CHALLAN_PAGE_TYPE.FINAL_PAGE,
        journey: isNonVahanState ? WHATSAPP_CHALLAN_JOURNEY.ULIP_SKIPPED : WHATSAPP_CHALLAN_JOURNEY.ULIP_CHECKED,
        vasAmount: vasAmount?.toString() || '0',
      })
    }
  }, [loaded])

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setLoaded(true)
      },
      scanListLength * 2200 + 1800
    )
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={`${styles.quickScanContainer} ${isNationalVehicle ? styles.lessDelay : ''}`}>
      <div className={styles.heading}>{heading}</div>
      <div className={styles.scanTypeContainer}>
        {scanList?.map((scanType, idx) => (
          <div className={styles.scanType} key={idx}>
            <div className={styles.scanTopContainer}>
              <div className={styles.scanHeading}>{scanType?.title}</div>
              <div className={styles.scanStatus}>
                <Image
                  src={statusConfig[scanType?.status]?.statusImageSrc}
                  alt="Status Image"
                  width={16}
                  height={16}
                  className={styles.statusImage}
                />
                <span className={`${styles.statusText} ${styles[scanType?.status]}`}>
                  {statusConfig[scanType?.status]?.statusText}
                </span>
              </div>
            </div>
            <div className={`${styles.progressBar} ${styles[scanType?.variant]}`} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default memo(QuickScan)
